module.exports = __webpack_public_path__ + "img/research-group-8.5989f506.jpg";